import { Box } from "@mui/material";
import { withFlexBase } from "v2/components/base/Flex/hocs/withFlexBase";

const FlexContainerUI = {
  Row: withFlexBase(Box, "row"),
  Col: withFlexBase(Box, "column"),
};

const RowUI = FlexContainerUI.Row;
const ColUI = FlexContainerUI.Col;

export { RowUI, ColUI };
